import React, { useEffect } from 'react'
import { HDatePicker, HInput, HTextarea, passParamsThrough } from '../../../validation/HForm'
import { maxLength } from '../../../helpers/data-constants'
import { formattingDate } from '../../../helpers/common';
import CharCount from '../CharCount/CharCount'

const IEAdd = (props) => {
    const { watch, setValue } = props
    const dateStateRegistrationValue = watch("dateStateRegistration");

    useEffect(() => {
        setValue("dateStateRegistration", formattingDate(dateStateRegistrationValue || null));
      }, []);
     
    return (
        passParamsThrough(<div className="modal-body serviceInformationAdd serviceInformationAdd-grid-container grid-cols-2">
            <div className="form-element">
                <label className="form-element-label" htmlFor="clientAddCountry">Адрес сайта</label>
                <div className="form-element-data">
                    <HInput h="true" className="input" type="text" name="siteUrl" id="siteUrl" />
                </div>
            </div>
            <div className="form-row">
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="startDate">Предполагаемый среднемесячный оборот</label>
                        <div className="form-element-data">
                            <HInput h="true" className="input" type="text" name="turnover" id="turnover" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="startDate">Регистрационный номер</label>
                        <div className="form-element-data">
                            <HInput h="true" className="input" type="text" name="registrationNumber" id="registrationNumber" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="dateStateRegistration">Дата государственной регистрации</label>
                        <div className="form-element-data">
                            <HDatePicker
                                h="true"
                                className="input"
                                name="dateStateRegistration"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="startDate">Наименование регистрирующего органа</label>
                        <div className="form-element-data">
                            <HInput h="true" className="input" type="text" name="registeringAuthority" id="registeringAuthority" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="startDate">УНП</label>
                        <div className="form-element-data">
                            <HInput h="true" className="input" type="text" name="payerNumber" id="payerNumber" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-row">
                <div className="form-row-item">
                    <div className="form-element">
                        <label className="form-element-label" htmlFor="startDate">Виды деятельности</label>
                        <div className="form-element-data">
                            <HInput h="true" className="input" type="text" name="activities" id="activities" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-element col-span-2">
                <label
                    className="form-element-label"
                    htmlFor="decisionMakersInfo"
                >
                    Сведения о лицах способных определить решение ИП
                </label>
                <div className="form-element-data textarea description">
                    <HTextarea
                    h="true"
                    className="input"
                    rows="4"
                    cols="10"
                    name="decisionMakersInfo"
                    id="decisionMakersInfo"
                    />
                </div>
                <CharCount
                    value={watch("decisionMakersInfo")}
                    maxLength={maxLength.SERVICE_INFORMATION_RISK}
                />
                </div>
        </div>, props)
    )
}

export default IEAdd
